import messages_ko from "./ko.json";
import messages_en from "./en.json";

const languages = {
    'ko': messages_ko,
    'en': messages_en
};

export default languages;
